import { render, staticRenderFns } from "./AlertRelatedGroups.vue?vue&type=template&id=3cf42863&scoped=true&"
import script from "./AlertRelatedGroups.vue?vue&type=script&lang=js&"
export * from "./AlertRelatedGroups.vue?vue&type=script&lang=js&"
import style0 from "./AlertRelatedGroups.vue?vue&type=style&index=0&id=3cf42863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf42863",
  null
  
)

export default component.exports